<script setup lang="ts">
import LoginButton from './LoginButton.vue';
import { useAuthentication } from '../composables/useAuthentication';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        noAuthMessage?: string;
        noAuthSeverity?: 'error' | 'success' | 'info' | 'warn';
        noAuthIcon?: string;
        noTeamMessage?: string;
        noTeamSeverity?: 'error' | 'success' | 'info' | 'warn';
        noTeamIcon?: string;
        requireTeam?: boolean;
    }>(),
    {
        noAuthMessage: 'Inhoud alleen beschikbaar als u bent ingelogd.',
        noAuthSeverity: 'error',
        noAuthIcon: 'pi-lock',
        noTeamMessage:
            'Inhoud alleen beschikbaar als u bent ingelogd als een teamlid.',
        noTeamSeverity: 'warn',
        noTeamIcon: 'pi-exclamation-circle',
    }
);

const { hasTeam, isAuthenticated } = useAuthentication();

const allowed = computed(() => {
    return isAuthenticated.value && (!props.requireTeam || hasTeam.value);
});

const severity = computed(() =>
    isAuthenticated.value ? props.noTeamSeverity : props.noAuthSeverity
);

const buttonSeverity = computed(() => {
    switch (severity.value) {
        case 'error':
            return 'danger';
        case 'warn':
            return 'warning';
        default:
            return severity.value;
    }
});

const icon = computed(() =>
    isAuthenticated.value ? props.noTeamIcon : props.noAuthIcon
);
const message = computed(() =>
    isAuthenticated.value ? props.noTeamMessage : props.noAuthMessage
);
</script>

<template>
    <template v-if="allowed">
        <slot />
    </template>

    <template v-else>
        <div
            v-bind="$attrs"
            class="p-message p-component"
            :class="`p-message-${severity}`"
            role="alert"
        >
            <div class="p-message-wrapper">
                <span class="p-message-icon pi" :class="icon" />
                <div class="p-message-text">
                    <slot name="message">
                        {{ message }}
                    </slot>
                </div>
                <LoginButton
                    v-if="!isAuthenticated"
                    class="ml-auto p-button-outlined"
                    :severity="buttonSeverity"
                />
            </div>
        </div>
    </template>
</template>
